export default __webpack_public_path__ + "static/media/icon-warning.8d8ce4f4.svg";